/**
 * Stable mock payloads shared by {@link CustomMetricsMockClient}.
 * Same TypeScript types as the HTTP client JSON responses.
 */
import type {
  CatalogMetricsResponse,
  HeadlinesMetricsResponse,
  OverviewMetricsResponse,
  SearchMetricsResponse,
  TemplatesMetricsResponse,
  UsersMetricsResponse,
} from '../types';

export const MOCK_OVERVIEW: OverviewMetricsResponse = {
  totalActions: 12840,
  trend: [
    { date: 'Feb 23', value: 2100 },
    { date: 'Mar 2', value: 2350 },
    { date: 'Mar 9', value: 2480 },
    { date: 'Mar 16', value: 2510 },
  ],
};

export const MOCK_USERS: UsersMetricsResponse = {
  engagedPercent: 23,
  engagedCount: 230,
  totalUsers: 1000,
  trend: [
    { day: '2026-02-23', users: 12 },
    { day: '2026-03-02', users: 15 },
    { day: '2026-03-09', users: 18 },
    { day: '2026-03-16', users: 16 },
  ],
};

export const MOCK_CATALOG: CatalogMetricsResponse = {
  mostVisited: [
    { page: '/catalog/default/component/api-alpha', visits: 420 },
    { page: '/catalog/default/component/web-beta', visits: 310 },
    { page: '/catalog/default/component/worker-gamma', visits: 205 },
  ],
  visitsTrend: [
    { date: 'Feb 23', value: 1800 },
    { date: 'Mar 2', value: 1920 },
    { date: 'Mar 9', value: 2010 },
    { date: 'Mar 16', value: 1980 },
  ],
};

export const MOCK_TEMPLATES: TemplatesMetricsResponse = {
  totalRuns: 1842,
  topTemplates: [
    { entityRef: 'template:default/nodejs', displayName: 'Node.js service', runs: 48 },
    { entityRef: 'template:default/react', displayName: 'React app', runs: 31 },
    { entityRef: 'template:default/python', displayName: 'Python API', runs: 22 },
  ],
  runsTrend: [
    { day: '2026-02-23', runs: 400 },
    { day: '2026-03-02', runs: 450 },
    { day: '2026-03-09', runs: 520 },
    { day: '2026-03-16', runs: 472 },
  ],
};

export const MOCK_SEARCH: SearchMetricsResponse = {
  totalSearches: 9033,
  searchesTrend: [
    { date: 'Feb 23', value: 42 },
    { date: 'Mar 2', value: 38 },
    { date: 'Mar 9', value: 28 },
    { date: 'Mar 16', value: 18 },
  ],
};

export const MOCK_HEADLINES: HeadlinesMetricsResponse = {
  users: {
    engagedPercent: MOCK_USERS.engagedPercent,
    engagedCount: MOCK_USERS.engagedCount,
    totalUsers: MOCK_USERS.totalUsers,
    trend: MOCK_USERS.trend,
  },
  templates: {
    totalRuns: MOCK_TEMPLATES.totalRuns,
    topTemplates: MOCK_TEMPLATES.topTemplates,
    runsTrend: MOCK_TEMPLATES.runsTrend,
  },
  search: {
    totalSearches: MOCK_SEARCH.totalSearches,
    searchesTrend: MOCK_SEARCH.searchesTrend,
  },
};
